module.exports = __webpack_public_path__ + "static/img/MAG3.16f3bec4.jpg";